<template>
  <main class="page __no-header" id="checkout">
    <div class="wrapper">
      <div class="grid">
        <section>
          <router-link tag="a" :to="{ name: 'home' }">
            <img src="img/logos/logo_full@2x.png" alt="">
          </router-link>
        </section>
        <section class="content">
          <div>
            <div v-if="$route.query.r === undefined">
              <h4>Email enviado!</h4>
              <p>Enviamos uma mensagem para {{ email }} com um link para ativar sua conta.</p>
              <a @click="resend">Não recebeu o email? Reenviar.</a>
              <transition name="fade">
                <p v-if="resent">Email reenviado, caso não tenha recebido, verifique sua caixa de spam.</p>
                <p v-else-if="resent === false">Não foi possível reenviar agora. Aguarde 1 minuto e tente de novo.</p>
              </transition>
            </div>
            <div v-else>
              <h4>Algo de errado aconteceu!!!</h4>
              <p>O link utilizado expirou ou já foi usado.</p>
              <a @click="resend">Reenviar.</a>
            </div>
          </div>
          <footer>
            &copy; 2019 Todos os direitos reservados. RACE é uma marca registrada pelo INPI.
            <nav>
              <ul>
                <router-link tag="li" :to="{ name: 'home' }">INÍCIO</router-link>
                <router-link tag="li" :to="{ name: 'services' }">SERVIÇOS</router-link>
                <router-link tag="li" :to="{ name: 'network' }">REDE</router-link>
                <router-link tag="li" :to="{ name: 'about' }">EMPRESA</router-link>
                <router-link tag="li" :to="{ name: 'contact' }">CONTATO</router-link>
              </ul>
            </nav>
          </footer>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
// Depois do cadastro: avisa que o link de ativacao foi enviado e permite pedir outro.
export default{
  name: 'checkout',
  data () {
    return {
      email: null,
      resent: undefined
    }
  },
  beforeMount () {
    let submission = null
    try { submission = JSON.parse(window.localStorage.getItem('submission')) } catch (e) {}
    this.email = this.$route.query.email || (submission && submission.email) || null
  },
  methods: {
    resend () {
      if (!this.email) return
      this.$Progress.start()
      this.$http.post(this.$api({ target: 'account/resend-activation' }), { email: this.email }).then(() => {
        this.$Progress.finish()
        this.resent = true
      }).catch(() => {
        this.$Progress.fail()
        this.resent = false
      })
    }
  }
}
</script>
